import { useMemo } from 'react'

import { useApiGetAtasan } from 'api/kinerja/kepala-sekolah/atasan'
import { blocks } from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/constants'
import Detail from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail'

import type {
  TListDataBlockKey,
  TListData,
} from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/types'
import type { School } from 'types/kinerja-ks'

const [keySeparator, keyPs, keyDinas] = ['_', 'PS', 'DINAS']

export const useData = ({ npsn }: { npsn: School['npsn'] }) => {
  const {
    data: { data: atasan } = {},
    isLoading,
    isError,
  } = useApiGetAtasan(npsn, {
    enabled: !!npsn,
  })

  const { dataKey, listItems, block, hasAtasan }: TListData = useMemo(() => {
    const dataKey = [
      keyPs,
      atasan?.pengawas?.status || 'NULL',
      keyDinas,
      atasan?.dinas?.status || 'NULL',
    ]
      .join(keySeparator)
      ?.toUpperCase() as TListDataBlockKey

    return {
      dataKey,
      listItems: [
        {
          label: 'Tim Kerja (Pengawas Sekolah)',
          value: atasan?.pengawas?.nama,
          status: atasan?.pengawas?.status || null,
          callback: (val) => (
            <Detail.Callback
              dataKey={dataKey}
              {...val}
              prefix={`${keyPs}${keySeparator}`}
            />
          ),
        },
        {
          label: 'Daerah Dinas Pendidikan',
          value: atasan?.dinas?.wilayah,
          status: atasan?.dinas?.status || null,
          callback: (val) => (
            <Detail.Callback
              dataKey={dataKey}
              {...val}
              prefix={`${keyDinas}${keySeparator}`}
            />
          ),
        },
      ],
      block: blocks?.[dataKey] || null, // Set as `null` as fallback so it won't be rendered
      hasAtasan: atasan?.hasAtasan || false,
    }
  }, [
    atasan?.dinas?.status,
    atasan?.dinas?.wilayah,
    atasan?.hasAtasan,
    atasan?.pengawas?.nama,
    atasan?.pengawas?.status,
  ])

  return {
    isLoading,
    isError,
    atasan,
    hasAtasan,
    dataKey,
    listItems,
    block,
  }
}
